import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import waveAuth from '../../services/wave/waveAuth';
import { useWaveAuth } from '../../context/WaveAuthContext';
import './Callback.css';

function WaveCallback() {
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { setIsAuthenticated } = useWaveAuth();

  useEffect(() => {
    let mounted = true;

    async function handleCallback() {
      try {
        const params = new URLSearchParams(location.search);
        const code = params.get('code');
        
        if (!code) {
          if (mounted) {
            setStatus('error');
            setError('No authorization code received');
          }
          return;
        }

        console.log('Received auth code:', code);
        
        const success = await waveAuth.handleCallback(code);

        if (!success && mounted) {
          setStatus('error');
          setError('Failed to get access token');
          return;
        }
        
        if (mounted) {
          setIsAuthenticated(true);
          setStatus('success');
          // Navigate to home on success
          navigate('/', { replace: true });
        }
      } catch (err) {
        console.error('Auth error:', err);
        if (mounted) {
          setStatus('error');
          setError(err.message || 'Authentication failed');
        }
      }
    }

    handleCallback();

    return () => {
      mounted = false;
    };
  }, [location, navigate, setIsAuthenticated]);

  if (status === 'error') {
    return (
      <div className="callback-error">
        <h2>Authentication Error</h2>
        <div className="error-message">{error}</div>
        <button 
          onClick={() => navigate('/wave-auth')} 
          style={{
            padding: '8px 16px',
            backgroundColor: '#0073ea',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginTop: '16px'
          }}
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="callback-loading">
      <h2>Completing authentication...</h2>
      <p>Please wait while we connect your Wave account.</p>
    </div>
  );
}

export default WaveCallback; 